import { LockDialog } from './LockDialog.js';

function HandleMeasurementDiagram() {
  return (
    <svg
      viewBox="0 0 320 300"
      className="mt-4 h-auto w-full"
      role="img"
      aria-label="Handle height from the bottom of the door to the centre of the handle and lock tongue"
    >
      <text x="4" y="12" fontSize="8" fill="#9CA3AF">
        VIEWED FROM OUTSIDE
      </text>
      <rect
        x="54"
        y="24"
        width="100"
        height="246"
        fill="white"
        stroke="#374151"
        strokeWidth="1.6"
      />
      <rect x="62" y="32" width="84" height="230" fill="#F3F4F6" stroke="#9CA3AF" />
      {[46, 150, 250].map((y) => (
        <rect key={y} x="154" y={y - 8} width="4" height="16" fill="#374151" />
      ))}
      <rect x="61" y="136" width="7" height="28" rx="2" fill="white" stroke="#374151" />
      <rect x="64" y="147.5" width="26" height="5" rx="2.5" fill="white" stroke="#374151" />
      <circle cx="64.5" cy="150" r="2.2" fill="var(--brand-progress)" />
      <circle
        cx="68"
        cy="150"
        r="20"
        fill="none"
        stroke="var(--brand-progress)"
        strokeDasharray="3 2"
      />
      <line
        x1="30"
        y1="150"
        x2="300"
        y2="150"
        stroke="var(--brand-progress)"
        strokeDasharray="4 3"
      />
      <line x1="30" y1="270" x2="180" y2="270" stroke="#9CA3AF" />
      <text x="154" y="284" fontSize="8" fill="#9CA3AF" textAnchor="end">
        BOTTOM OF DOOR
      </text>
      <line x1="38" y1="155" x2="38" y2="265" stroke="var(--brand-progress)" strokeWidth="1.3" />
      <path d="M38 152l-3.5 6h7ZM38 268l-3.5-6h7Z" fill="var(--brand-progress)" />
      <text x="4" y="120" fontSize="9.5" fontWeight="700" fill="#C2410C">
        Handle
      </text>
      <text x="4" y="131" fontSize="9.5" fontWeight="700" fill="#C2410C">
        height
      </text>
      <rect x="182" y="96" width="132" height="110" rx="8" fill="white" stroke="#D1D5DB" />
      <text x="190" y="110" fontSize="7" fill="#9CA3AF">
        DOOR EDGE CLOSE-UP
      </text>
      <rect x="236" y="116" width="26" height="84" fill="#F9FAFB" stroke="#374151" />
      <rect x="242" y="126" width="14" height="46" rx="1.5" fill="white" stroke="#374151" />
      <rect x="245" y="145" width="8" height="10" fill="white" stroke="#374151" />
      <rect x="198" y="147.5" width="34" height="5" rx="2.5" fill="white" stroke="#374151" />
      <rect x="266" y="147.5" width="34" height="5" rx="2.5" fill="white" stroke="#374151" />
      <line x1="253" y1="153" x2="260" y2="180" stroke="#374151" />
      <text x="256" y="188" fontSize="7.5" fill="#374151">
        Lock tongue
      </text>
    </svg>
  );
}

export function HandleMeasurementHelp() {
  return (
    <LockDialog
      name="lock-height-help"
      topic="handle_height"
      title="Where your handle is measured"
      triggerLabel="Where your handle is measured"
      triggerName="lock-height-help"
      triggerClassName="inline-flex size-11 shrink-0 items-center justify-center rounded-full text-progress focus-visible:outline-2 focus-visible:outline-progress"
      trigger={
        <svg
          aria-hidden="true"
          className="size-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.6 9.2a2.5 2.5 0 0 1 4.8 1c0 1.7-2.4 2.1-2.4 3.6" strokeLinecap="round" />
          <circle cx="12" cy="17.2" r=".6" fill="currentColor" stroke="none" />
        </svg>
      }
    >
      {() => (
        <>
          <p className="mt-1 text-xs text-gray-500">
            Measure from the bottom of the manufactured door to the centre of the handle, aligned
            with the lock tongue.
          </p>
          <HandleMeasurementDiagram />
          <p className="mt-3 text-sm font-semibold text-gray-800">
            Centre of handle = centre of lock tongue
          </p>
          <p className="mt-1 text-xs leading-relaxed text-gray-500">
            The striker plate on your frame is fitted afterwards to line up with the tongue.
          </p>
        </>
      )}
    </LockDialog>
  );
}
